/*
 * The UI side of the shared URL module (avoconsulte-be/src/seo/urls.js).
 * Builders return decoded paths: pass them to navigate() as-is and through
 * toHref() for href attributes.
 */
import urls from "@seo/urls";
import copy from "@seo/copy";

export { urls, copy };

/** The page language, decided by boot.js from the URL. Read at render. */
export function currentLang() {
  let lang = null;
  try {
    lang = localStorage.getItem("lang");
  } catch (e) {
    lang = null;
  }
  return urls.LANGS.includes(lang) ? lang : urls.DEFAULT_LANG;
}

/** The current pathname, decoded and without a trailing slash. */
export function currentPath(pathname = window.location.pathname) {
  let path = pathname;
  try {
    path = decodeURIComponent(pathname);
  } catch (e) {
    path = pathname;
  }
  return path.replace(/\/+$/, "") || "/";
}

/** Same path, ignoring a trailing slash and percent-encoding. */
export function samePath(a, b) {
  return currentPath(a) === currentPath(b);
}

/** href for a section listing (lawyers, questions, blogs, about, contact, terms). */
export function sectionHref(type, lang = currentLang()) {
  return urls.toHref(urls.sectionPath(type, lang));
}

/**
 * Switch language on the page being viewed. The server lists the page in
 * every language as <link rel="alternate" hreflang>; pages without one go to
 * that language's home. A full navigation, so the other direction's
 * stylesheet loads.
 */
export function switchLanguage(lang) {
  try {
    localStorage.setItem("lang", lang);
  } catch (e) {
    // The target URL carries the language anyway.
  }
  const alternate = document.querySelector(`link[rel="alternate"][hreflang="${lang}"]`);
  window.location.assign((alternate && alternate.href) || urls.toHref(urls.homePath(lang)));
}
